/* eslint-disable func-names */
import $ from "jquery";
import Swiper from 'swiper';
import { Autoplay, Pagination, Navigation, EffectFade, Scrollbar } from 'swiper/modules';
import 'swiper/css/bundle';
import 'swiper/css/effect-fade';

const slider = () => {
    // wrapperにlinearのtransitionを適用
    const applyLinearTransition = (swiperInstance) => {
        const wrapper = swiperInstance.wrapperEl;
        if (wrapper) {
            wrapper.style.transitionTimingFunction = 'linear';
        }
    };

    // 1行目のスライダー（左から右へ）
    const swiperRow1 = new Swiper('.js-slider-right', {
        modules: [Autoplay],
        loop: true,
        loopAdditionalSlides: 1,
        slidesPerView: 2,
        speed: 10000,
        spaceBetween: 20,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        freeMode: {
            enabled: true,
            momentum: false,
        },
        allowTouchMove: false,
        breakpoints: {
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 5,
            }
        },
        on: {
            init: function () {
                applyLinearTransition(this);
            },
            slideChange: function () {
                applyLinearTransition(this);
            }
        }
    });

    // 2行目のスライダー（右から左へ）
    const swiperRow2 = new Swiper('.js-slider-left', {
        modules: [Autoplay],
        loop: true,
        loopAdditionalSlides: 1,
        slidesPerView: 2,
        speed: 10000,
        spaceBetween: 20,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: true,
        },
        freeMode: {
            enabled: true,
            momentum: false,
        },
        allowTouchMove: false,
        breakpoints: {
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 5,
            }
        },
        on: {
            init: function () {
                applyLinearTransition(this);
            },
            slideChange: function () {
                applyLinearTransition(this);
            }
        }
    });
}

const main = () => {
    if (document.querySelector('#page-reform') === null) return;
    slider();
}
export default main;
